





import { Component, Vue, Prop } from 'vue-property-decorator';

@Component<Title>({})
export default class Title extends Vue {
  //
}
